import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { QUERY_PARAMS } from "@/routes/_constants";
import { PATHS } from "@/routes/paths";

import { DiscountLongTermStayNewPage } from "@/components/features/items/discount/item/long-term-stay/new/ui";
import { DiscountMultiNewPage } from "@/components/features/items/discount/item/multi/new/ui";
import { DiscountOrdinaryNewPageContainer } from "@/components/features/items/discount/item/ordinary/new/ui";

import { useConfirmParams } from "./hooks";

export const DiscountDuplicatePage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID, type, duplicateDiscountID } = result;

	if (type === "ordinary")
		return (
			<PageMeta
				title="通常ディスカウントの複製"
				url={generatePath(PATHS.HOTEL.ITEMS.DISCOUNT.DUPLICATE, {
					hotelID,
					type: QUERY_PARAMS.ITEMS.DISCOUNT.TYPE.ORDINARY,
					duplicateDiscountID,
				})}
			>
				<DiscountOrdinaryNewPageContainer hotelID={hotelID} duplicateDiscountID={duplicateDiscountID} />
			</PageMeta>
		);

	if (type === "long-term-stay")
		return (
			<PageMeta
				title="連泊ディスカウントの複製"
				url={generatePath(PATHS.HOTEL.ITEMS.DISCOUNT.DUPLICATE, {
					hotelID,
					type: QUERY_PARAMS.ITEMS.DISCOUNT.TYPE.LONG_TERM_STAY,
					duplicateDiscountID,
				})}
			>
				<DiscountLongTermStayNewPage hotelID={hotelID} duplicateDiscountID={duplicateDiscountID} />;
			</PageMeta>
		);

	return (
		<PageMeta
			title="複合ディスカウントの複製"
			url={generatePath(PATHS.HOTEL.ITEMS.DISCOUNT.DUPLICATE, {
				hotelID,
				type: QUERY_PARAMS.ITEMS.DISCOUNT.TYPE.MULTI,
				duplicateDiscountID,
			})}
		>
			<DiscountMultiNewPage hotelID={hotelID} duplicateDiscountID={duplicateDiscountID} />
		</PageMeta>
	);
};
